(function () {
  'use strict';

  angular
    .module('app.store-detail', [])

    .directive('store', function () {
      return {
        restrict: 'E',
        bindToController: {
          device: '<',
          name: '@',
          latitude: '<',
          longitude: '<',
          model: '<',
          daysModel: '@days',
          strOneTime: '@oneTime',
          strTwoTimes: '@twoTimes',
          strClosed: '@closed'
        },
        controllerAs: 'storeCtrl',
        /* @ngInject */
        controller: ["$window", "GMaps", "StoresService", function ($window, GMaps, StoresService) {
          var ctrl = this;

          ctrl.$onInit = function () {
            ctrl.OpeningHours = _.cloneDeep(ctrl.model);
            ctrl.days = ctrl.daysModel.split(',');
            ctrl.model = null;
            ctrl.daysModel = null;

            StoresService.getOpeningHours(ctrl, ctrl.days, ctrl.strOneTime, ctrl.strTwoTimes, ctrl.strClosed);

            ctrl.loading = true;
            GMaps.get()
              .then(setMap)
              .catch(function (error) {
                console.error(error);
              });

          };

          ctrl.getMarkerOpts = function () {
            return {
              title: null,
              icon: { url: '/img/gmap/store-gmap-active.png', labelOrigin: new google.maps.Point(20, 70) },
              label: { text: ctrl.name, fontWeight: 'bold' },
              zIndex: 3
            };
          };

          ctrl.activeTab = function () {
            $window.dispatchEvent(new CustomEvent('resize'));
          };

          // Functions

          function setMap() {
            ctrl.markers = [];
            ctrl.markers.push({
              id: 0,
              lat: ctrl.latitude,
              lng: ctrl.longitude
            });

            ctrl.options = {
              map: {
                center: new google.maps.LatLng(ctrl.latitude, ctrl.longitude),
                zoom: 8,
                styles: [
                  {
                    'stylers': [
                      {
                        'saturation': -100
                      },
                      {
                        'lightness': 50
                      }
                    ]
                  },
                  {
                    'featureType': 'poi',
                    'stylers': [
                      {
                        'visibility': 'off'
                      }
                    ]
                  }
                ]
              }
            };

            ctrl.showMap = true;
            ctrl.loading = false;
          }

        }]
      };
    });

})();
